import translate from 'rcm-i18n';
import React, { Component } from 'react';
import type PotentialOrderLineDictionary from './PotentialOrderLineDictionary';
import type SkuLine from './SkuLine';
import SkuSectionSkuLineComponent from './SkuSectionSkuLineComponent';

interface Props {
  label: string;
  skuLines: SkuLine[];
  potentialOrderLines: PotentialOrderLineDictionary;
  onSkuQuantityChange: (skuLine: SkuLine, newQuantity: number) => void;
  showBvPv: boolean;
}

const SkuSectionComponent = ({
  label,
  skuLines,
  potentialOrderLines,
  onSkuQuantityChange,
  showBvPv,
}: Props) => {
  const showVat = skuLines.some((s: SkuLine) => {
    return s.data?.vatAmount !== undefined;
  });

  return skuLines.length ? (
    <tbody>
      <tr className='quick-shop-with-sections-sku-section-header'>
        <th colSpan={2}>{label}</th>
        {/*<th className="hidden-xs">{translate('Item')}</th>*/}
        {showBvPv && <th className='hidden-xs'>{translate('BV')}</th>}
        {showBvPv && <th className='hidden-xs'>{translate('PV')}</th>}
        <th className='vat-price'>{translate('Price')}</th>
        {showVat && <th className='vat-price'>{translate('Price + VAT')}</th>}
        <th className='hidden-xs'>{translate('Qty')}</th>
        <th className='hidden-xs'>{translate('Total')}</th>
      </tr>
      {skuLines.map((skuLine, index) => (
        <SkuSectionSkuLineComponent
          key={index}
          skuLine={skuLine}
          potentialOrderLine={potentialOrderLines[skuLine.skuNumber]}
          onQuantityChange={onSkuQuantityChange}
          showBvPv={showBvPv}
          skuNumber={skuLine.skuNumber}
          showVat={showVat}
        />
      ))}
    </tbody>
  ) : null;
};

export default SkuSectionComponent;
